// ---------------------------
// AUTO-GENERATED. DO NOT EAT.
// ---------------------------

import { createEnum } from "@cartographerio/util";

import { SurveyPermissionModel } from "../types.generated";

const RoleBasedSensitive: SurveyPermissionModel = "RoleBasedSensitive";
const RoleBased: SurveyPermissionModel = "RoleBased";
const WorkspaceVisible: SurveyPermissionModel = "WorkspaceVisible";
const WorkspaceDownloadable: SurveyPermissionModel = "WorkspaceDownloadable";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const SurveyPermissionModelEnum = {
  ...createEnum("SurveyPermissionModel", [
    [RoleBasedSensitive, "Requires explicit roles (sensitive)"],
    [RoleBased, "Requires explicit roles"],
    [WorkspaceVisible, "Visible when logged into the same workspace"],
    [WorkspaceDownloadable, "Downloadable when logged into the same workspace"],
  ]),
  RoleBasedSensitive,
  RoleBased,
  WorkspaceVisible,
  WorkspaceDownloadable,
};

export default SurveyPermissionModelEnum;
